import { fetchAccessToken } from './token-service';

let accessToken: string | null = localStorage.getItem('accessToken');
let tokenExpirationTime: number | null = localStorage.getItem('tokenExpirationTime')
	? parseInt(localStorage.getItem('tokenExpirationTime')!)
	: null;

const shouldFetchToken = !accessToken || !tokenExpirationTime || Date.now() >= tokenExpirationTime;

export const getRequest = async (url: string): Promise<any> => {
	try {
		if (shouldFetchToken) {
			await fetchAccessToken();
			accessToken = localStorage.getItem('accessToken');
			tokenExpirationTime = localStorage.getItem('tokenExpirationTime')
				? parseInt(localStorage.getItem('tokenExpirationTime')!)
				: null;
		}
		const response = await fetch(url, {
			method: 'GET',
			headers: {
				Authorization: `Bearer ${accessToken}`,
			},
		});

		if (!response.ok) {
			throw new Error(`HTTP error! Status: ${response.status}`);
		}

		return await response.json();
	} catch (error) {
		console.error('Error making GET request:', error);
		throw error;
	}
};

export const postRequest = async (url: string, data: any): Promise<any> => {
	try {
		if (shouldFetchToken) {
			await fetchAccessToken();
			accessToken = localStorage.getItem('accessToken');
			tokenExpirationTime = localStorage.getItem('tokenExpirationTime')
				? parseInt(localStorage.getItem('tokenExpirationTime')!)
				: null;
		}
		const response = await fetch(url, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${accessToken}`,
			},
			body: JSON.stringify(data),
		});

		if (!response.ok) {
			throw new Error(`HTTP error! Status: ${response.status}`);
		}

		return await response.json();
	} catch (error) {
		console.error('Error making POST request:', error);
		throw error;
	}
};

export const uploadRequest = async (url: string, data: any): Promise<any> => {
	try {
		if (shouldFetchToken) {
			await fetchAccessToken();
			accessToken = localStorage.getItem('accessToken');
			tokenExpirationTime = localStorage.getItem('tokenExpirationTime')
				? parseInt(localStorage.getItem('tokenExpirationTime')!)
				: null;
		}
		const response = await fetch(url, {
			method: 'POST',
			headers: {
				Authorization: `Bearer ${accessToken}`,
			},
			body: data
		});

		if (!response.ok) {
			throw new Error(`HTTP error! Status: ${response.status}`);
		}

		return await response.json();
	} catch (error) {
		console.error('Error making POST request:', error);
		throw error;
	}
};

export const deleteRequest = async (url: string, data: any): Promise<any> => {
	try {
		if (shouldFetchToken) {
			await fetchAccessToken();
			accessToken = localStorage.getItem('accessToken');
			tokenExpirationTime = localStorage.getItem('tokenExpirationTime')
				? parseInt(localStorage.getItem('tokenExpirationTime')!)
				: null;
		}
		const response = await fetch(url, {
			method: 'DELETE',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${accessToken}`,
			},
			body: JSON.stringify(data),
		});

		if (!response.ok) {
			throw new Error(`HTTP error! Status: ${response.status}`);
		}

		return await response.json();
	} catch (error) {
		console.error('Error making DELETE request:', error);
		throw error;
	}
};
